import styled from 'styled-components';
import { IFrame } from './interface';

const base = styled.div<IFrame>`
  display: grid;
  justify-content: stretch;
  height: 80vh;
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  min-width: 60%;
  grid-template-areas:
    'totais totais totais totais'
    'totais totais totais totais'
    'apuracao apuracao encerradas encerradas'
    'apuracao apuracao encerradas encerradas'
    'apuracao apuracao encerradas encerradas';
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  margin: 0.5rem 0 1rem 0;
  background-color: #ebf1f4;
`;

const pdfbutton = styled.div<IFrame>`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  background-color: #ebf1f4;
`;

const FrameGrid = {
  Base: base,
  PdfButton: pdfbutton,
};

export default FrameGrid;
